import React from 'react';
import UserManagement from '../Management';

const actions = {
    start: 'CREATE_USER_SUBMIT',
    resolve: 'CREATE_USER_SUCCEEDED',
    reject: 'CREATE_USER_FAILED'
};

const NewUser = () => (
    <UserManagement
        headerName="Cadastrar Usuário"
        actions={actions}
    />
);

export default NewUser;


// WEBPACK FOOTER //
// ./src/components/Pages/Users/New/index.js